import { useParams } from "react-router-dom"
import { ToastProvider } from "../../common/components/ui/toast/toast.provider"
import Dashboard from "../../common/components/layout/Dashboard"
import Toast from "../../common/components/ui/toast"
import { PurchaseOrderDashboardProvider } from "./components/purchase-order-dashboard/PurchaseOrder.provider"
import { PurchaseOrderDashboard } from "./components/purchase-order-dashboard"


export default function PurchaseOrderDetailsPage() {
  const { purchaseOrderId } = useParams();

  return (
    <ToastProvider>
      <Dashboard>
        <PurchaseOrderDashboardProvider purchaseOrderId={purchaseOrderId || ''}>
          <PurchaseOrderDashboard />
        </PurchaseOrderDashboardProvider>
      </Dashboard>
      <Toast />
    </ToastProvider>
  )
}

